"use client";

import { useNavigate } from "react-router-dom";

// Compnents
import { Row, Col, Card, CardBody } from "reactstrap";

// Hooks
import { useGetRubbishDynamicPrices } from "../../hooks/api/rubbish-dynamic-price/use-get-rubbish-dynamic-prices.hook";
import { useGetRubbishes } from "../../hooks/api/rubbish-dynamic-price/use-get-rubbishes";
import { useApiViewStatus } from "../../hooks/api/api-view-status/api-view-status.hook";

// Utils
import { moneyFormatterUtility } from "../../utilities/number/money-formatter.utility";
import { BaseIcon } from "../../components/base-icon/base-icon.component";

export default function HomeRubbishList({ location }) {
	const rubbishesQueryInfo = useGetRubbishes(location);

	const { apiIndicatorShow, apiIndicatorComponent } = useApiViewStatus(rubbishesQueryInfo.status);

	const rubbishPricesPerWeightQueryInfo = useGetRubbishDynamicPrices("999", location);

	const { apiIndicatorShow: rubbishesApiIndicatorShow } = useApiViewStatus(rubbishesQueryInfo.status);

	const rubbishPricesPerWeightQueryInfoMinMaxPrice =
		rubbishPricesPerWeightQueryInfo.data?.data &&
		Object.entries(rubbishPricesPerWeightQueryInfo.data?.data).reduce((acc, [key, values]) => {
			const allPrices = Object.values(values);
			const min = Math.min(...allPrices);
			const max = Math.max(...allPrices);
			acc[key] = { min, max };
			return acc;
		}, {});

	const navigate = useNavigate();

	const onRubbishCategory = ({ ID, TYPE }) => {
		navigate(`/rubbish-dynamic-price/${ID}`);
	};
	const categorizedRubbishes = rubbishesQueryInfo.data ?? [];

	const getRubbishPrice = (rubbishId, type) => {
		const item = rubbishPricesPerWeightQueryInfoMinMaxPrice[rubbishId];
		if (item) {
			if (type === "min") {
				return moneyFormatterUtility(item.min / 10);
			} else {
				return moneyFormatterUtility(item.max / 10);
			}
		} else {
			return 0;
		}
	};

	return (
		<Row className="rubbish-price-list pb-50">
			{apiIndicatorShow || rubbishesApiIndicatorShow ? (
				<Col xs={12} className="text-center">
					{apiIndicatorComponent()}
				</Col>
			) : categorizedRubbishes.length > 0 && rubbishPricesPerWeightQueryInfoMinMaxPrice ? (
				<div className="carousel-rubbish">
					<div className="group-rubbish">
						{categorizedRubbishes.map((rubbish) => (
							<Col xs={6} key={rubbish.ID} style={{ flex: "0 0 auto", maxWidth: "200px" }}>
								<Card
									className="cursor-pointer"
									style={{ boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.1)" }}
									onClick={() => onRubbishCategory({ ID: rubbish.ID, TYPE: rubbish.TYPE })}
								>
									<CardBody>
										<div className="d-flex flex-column align-items-center justify-content-center text-center">
											<span className="fw-600 f-12 title mb-50">{rubbish.TYPE}</span>

											<div className="w-100 d-flex flex-column">
												<div className="d-flex justify-content-between">
													<BaseIcon size={20} name="TrendingUp" className="text-success" />

													<div>
														<span className="fw-800 f-14">
															{getRubbishPrice(rubbish.ID, "max")}
														</span>
														<span className="f-12"> تومانء</span>
													</div>
												</div>

												<div className="d-flex justify-content-between">
													<BaseIcon size={20} name="TrendingDown" className="text-danger" />

													<div>
														<span className="fw-800 f-14">
															{getRubbishPrice(rubbish.ID, "min")}
														</span>
														<span className="f-12"> تومانء</span>
													</div>
												</div>
											</div>
										</div>
									</CardBody>
								</Card>
							</Col>
						))}
					</div>
				</div>
			) : (
				<Col xs={12} className="text-center">
					<p className="f-16 fw-600">هیچ اطلاعاتی برای نمایش وجود ندارد.</p>
				</Col>
			)}
		</Row>
	);
}
